import { AlertBar } from '@civilgrid/ui/components';
import { useFeatureFlagEnabled } from '@posthog/react';
import { useSnapshot } from 'valtio';
import type { OrganizationDetail, TLoadedState } from '~/common/types';
import rootStore from '~/store';

export const SUBSCRIPTION_INACTIVE_BANNER_FLAG = 'subscription-enable-inactive-banner';

/** Whether the inactive-subscription banner shows: flag on and the current org has no active subscription. */
export function useShowSubscriptionInactiveBanner(): boolean {
  const enabled = useFeatureFlagEnabled(SUBSCRIPTION_INACTIVE_BANNER_FLAG);
  const { currentOrganizationDetail } = useSnapshot(rootStore);
  if (!enabled || currentOrganizationDetail.isLoading) return false;
  return (currentOrganizationDetail as TLoadedState & OrganizationDetail).isSubscriptionActive === false;
}

export default function SubscriptionInactiveBanner() {
  return (
    <div data-testid="subscription-inactive-banner">
      <AlertBar layout="banner" variant="warning" icon="warning" title="Your organization's subscription isn't active.">
        Some features may be turned off soon. Contact your account admin or CivilGrid support to renew.
      </AlertBar>
    </div>
  );
}
